import { useMutation, useQuery } from "@tanstack/react-query";
import { apiGet, apiPost } from "@/lib/apiClient";
import type {
  AIChatMessagesRequest,
  ChatResponse,
  RecommendationRequest,
  RecommendationResponse,
  RoomCapacityResponse,
} from "@/types/recommendation";

export const recommendationKeys = {
  roomCapacities: ["recommendation", "room-capacities"] as const,
};

export function useRoomCapacities() {
  return useQuery({
    queryKey: recommendationKeys.roomCapacities,
    queryFn: () => apiGet<RoomCapacityResponse[]>("RoomCapacity"),
    staleTime: 10 * 60_000,
  });
}

export function useAtlasRecommendations() {
  return useMutation({
    mutationFn: (payload: RecommendationRequest) =>
      apiPost<RecommendationRequest, RecommendationResponse[]>("Recommendations/GetRecommendations", payload),
  });
}

export function usePostNlqChat() {
  return useMutation({
    mutationFn: (payload: AIChatMessagesRequest) =>
      apiPost<AIChatMessagesRequest, ChatResponse>("GenAI/PostUserPrompt", payload),
  });
}
